import styles from './Tag.module.scss'

export const Tag = ({ text, bgColor, customClass }) => (
  <div
    className={`
    ${styles.tag} 
    ${styles[`tag--${bgColor}`]} 
    ${customClass}
  `}
  >
    <label>{text}</label>
  </div>
)
